import React, { Suspense } from 'react';

interface SmoothPageTransitionProps {
  children: React.ReactNode;
}

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[200px]">
    <div className="flex flex-col items-center space-y-3">
      <div className="w-5 h-5 border-2 border-primary/20 border-t-primary rounded-full animate-spin" />
      <p className="text-xs text-muted-foreground">Carregando...</p>
    </div>
  </div>
);

export const SmoothPageTransition: React.FC<SmoothPageTransitionProps> = ({ children }) => {
  return (
    <Suspense fallback={<PageLoader />}>
      {children}
    </Suspense>
  );
};
